import React from "react";
import { NumberInput, required, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import EditIcon from "@mui/icons-material/Edit";
import { scholarshipRequests } from "api/scholarshipApi";
import { Button } from "@mui/material";
const UpdateScholarshipBudgetDialog = ({ budgetId, structuralUnitName }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      amount: data.amount,
    };
    await dataProvider.customRequest(
      scholarshipRequests.updateScholarshipBudgetStructuralUnit(budgetId),
      payload,
      "PUT",
    );
    notify(`Успешно редактирахте бюджет за факултет ${structuralUnitName}`, { type: "success" });
    refresh();
  };

  return (
    <>
      <FormModal
        titleContent={`Редактирай бюджет за ${structuralUnitName}`}
        onConfirm={handleSubmit}
        triggerButton={
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            size="small"
            color="warning"
          >
            Редактирай
          </Button>
        }
      >
        <NumberInput
          source="amount"
          label="Сума"
          validate={required()}
        />
      </FormModal>
    </>
  );
};

export default UpdateScholarshipBudgetDialog;
